import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoGroupBookingAction, 
  setIsFetching, 
  setFetchFailed, 
  setContent,
} from 'Pages/InfoGroupBookingPage/Redux/actions';

export const fetchGroupContent = () => {
  return async (dispatch: Dispatch<InfoGroupBookingAction>): Promise<void> => {
    const { isFetching, content } = Store.getState().infoGroupBooking;

    if (isFetching || content) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('GroupPage');

      if (response.status !== 200) {
        dispatch(setFetchFailed());
      } else {
        const newContent: Julius.Website.GroupPageViewModel = await response.json();
        dispatch(setContent(newContent));
      }
      
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/pages/InfoGroupBookingPage/Redux/thunks.tsx